import { defineMessage } from 'react-intl'

import { OPTIONS_TYPE, PreferenceMetadataConfig } from './types'
import { CountryNameToISOCode } from '../../intl/constants'
import {
  MEMBER_PREFERENCE_IDS,
  MEMBER_PREFERENCE_NAMES,
  S4C_PROGRAM_OPTION_FLOW,
} from '../../memberPreferences/constants'
import { MEMBER_PREFERENCE_LABELS } from '../../searchForCare/messages'

const optionsDefault = [
  {
    text: MEMBER_PREFERENCE_LABELS.asian,
    id: MEMBER_PREFERENCE_IDS.ASIAN,
  },
  {
    text: MEMBER_PREFERENCE_LABELS.blackOrAfricanAmerican, // TODO replace with 'black'. BE continues to recognize blackOrAfricanAmerican for backwards compatibility for now
    id: MEMBER_PREFERENCE_IDS.BLACK_OR_AFRICAN_AMERICAN,
  },
  {
    text: MEMBER_PREFERENCE_LABELS.hispanicOrLatinx,
    id: MEMBER_PREFERENCE_IDS.HISPANIC_OR_LATINX,
  },
  {
    text: MEMBER_PREFERENCE_LABELS.middleEasternOrNorthAfrican,
    id: MEMBER_PREFERENCE_IDS.MIDDLE_EASTERN_OR_NORTH_AFRICAN,
  },
  {
    text: MEMBER_PREFERENCE_LABELS.nativeAmericanOrAlaskaNative,
    id: MEMBER_PREFERENCE_IDS.NATIVE_AMERICAN_OR_ALASKA_NATIVE,
  },
  {
    text: MEMBER_PREFERENCE_LABELS.nativeHawaiianOrPacificIslander,
    id: MEMBER_PREFERENCE_IDS.NATIVE_HAWAIIAN_OR_PACIFIC_ISLANDER,
  },
  {
    text: MEMBER_PREFERENCE_LABELS.white,
    id: MEMBER_PREFERENCE_IDS.WHITE,
  },
]

const britishOptions = [
  {
    text: MEMBER_PREFERENCE_LABELS.asianBritish,
    id: MEMBER_PREFERENCE_IDS.ASIAN,
    selectedTextLabel: MEMBER_PREFERENCE_LABELS.asian,
  },
  {
    text: MEMBER_PREFERENCE_LABELS.blackBritishOrCaribbeanOrAfrican,
    id: MEMBER_PREFERENCE_IDS.BLACK,
    selectedTextLabel: MEMBER_PREFERENCE_LABELS.black,
  },
  {
    text: MEMBER_PREFERENCE_LABELS.white,
    id: MEMBER_PREFERENCE_IDS.WHITE,
  },
]

const irishOptions = [
  {
    text: MEMBER_PREFERENCE_LABELS.asianIrish,
    id: MEMBER_PREFERENCE_IDS.ASIAN,
    selectedTextLabel: MEMBER_PREFERENCE_LABELS.asian,
  },
  {
    text: MEMBER_PREFERENCE_LABELS.blackIrishOrCaribbeanOrAfrican,
    id: MEMBER_PREFERENCE_IDS.BLACK,
    selectedTextLabel: MEMBER_PREFERENCE_LABELS.black,
  },
  {
    text: MEMBER_PREFERENCE_LABELS.white,
    id: MEMBER_PREFERENCE_IDS.WHITE,
  },
]

const raceEthnicityTherapyPreference: PreferenceMetadataConfig = {
  name: MEMBER_PREFERENCE_NAMES.ETHNICITIES,
  title: MEMBER_PREFERENCE_LABELS.ethnicities,
  optionType: OPTIONS_TYPE.CHECKBOX,
  icon: 'MemberPreferencesRaceEthnicityIllustrationIcon',
  promptText: defineMessage({
    defaultMessage: 'I prefer a provider who identifies as any of the following:',
    description: 'Text prompting the user to select options they associate with',
  }),
  countryConfig: {
    [CountryNameToISOCode.Canada]: {
      programOptionFlows: [S4C_PROGRAM_OPTION_FLOW.THERAPY],
      options: [
        {
          text: MEMBER_PREFERENCE_LABELS.black,
          id: MEMBER_PREFERENCE_IDS.BLACK,
        },
        {
          text: MEMBER_PREFERENCE_LABELS.eastAsian,
          id: MEMBER_PREFERENCE_IDS.EAST_ASIAN,
        },
        {
          text: MEMBER_PREFERENCE_LABELS.indigenous,
          id: MEMBER_PREFERENCE_IDS.INDIGENOUS,
        },
        {
          text: MEMBER_PREFERENCE_LABELS.latinAmerican,
          id: MEMBER_PREFERENCE_IDS.HISPANIC_OR_LATINX,
        },
        {
          text: MEMBER_PREFERENCE_LABELS.middleEasternArabicOrNorthAfrican,
          id: MEMBER_PREFERENCE_IDS.MIDDLE_EASTERN_OR_NORTH_AFRICAN,
        },
        {
          text: MEMBER_PREFERENCE_LABELS.southAsian,
          id: MEMBER_PREFERENCE_IDS.SOUTH_ASIAN,
        },
        {
          text: MEMBER_PREFERENCE_LABELS.southeastAsian,
          id: MEMBER_PREFERENCE_IDS.SOUTHEAST_ASIAN,
        },
        {
          text: MEMBER_PREFERENCE_LABELS.whiteEuropeanCaucasian,
          id: MEMBER_PREFERENCE_IDS.WHITE,
        },
      ],
    },
    [CountryNameToISOCode.Ireland]: {
      programOptionFlows: [S4C_PROGRAM_OPTION_FLOW.THERAPY],
      options: irishOptions,
    },
    [CountryNameToISOCode.UnitedStatesOfAmerica]: {
      programOptionFlows: [S4C_PROGRAM_OPTION_FLOW.THERAPY],
      options: optionsDefault,
    },
    [CountryNameToISOCode.UnitedKingdom]: {
      programOptionFlows: [S4C_PROGRAM_OPTION_FLOW.THERAPY],
      options: britishOptions,
    },
  },
}

export default raceEthnicityTherapyPreference
